"use client";

import { useEffect, useCallback } from "react";

interface UsePullToRefreshOptions {
  onRefresh?: () => Promise<void>;
  enabled?: boolean;
}

/**
 * Hook for using pull-to-refresh in specific components
 * This is a simplified version that just registers a refresh handler
 * The actual pull-to-refresh logic is handled by the PullToRefresh component
 */
export function usePullToRefresh({ onRefresh, enabled = true }: UsePullToRefreshOptions = {}) {
  const handleRefresh = useCallback(async () => {
    if (onRefresh) {
      await onRefresh();
    } else {
      // Default behavior - reload the page
      window.location.reload();
    }
  }, [onRefresh]);

  useEffect(() => {
    if (!enabled) return;

    // For PWA environments, you might want to add additional logic here
    // For now, the PullToRefresh component handles everything

    return () => {
      // Cleanup if needed
    };
  }, [enabled]);

  return {
    refresh: handleRefresh,
    isEnabled: enabled,
  };
}